// For now we have to disable unsafe assignment for all reducers
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import { ITestResultState } from "../store/IRcaState";
import initialState from "../store/initialState";
import { AnyAction } from "@reduxjs/toolkit";
import {
  SET_TEST_RESULT_PROGRESS,
  LOAD_TEST_RESULT_SUCCESS,
  SET_TEST_NODE_EXPANDED,
  SET_TEST_NODE_EXPAND_COLLAPSE_ALL,
  LOAD_TEST_RESULT_ERROR,
  LOAD_TEST_RESULT_START,
} from "../actions/actionTypes";
import { Utils } from "../Utils";

/**
 * The redux reducer for the testResult slice of the state
 *
 * @param state - The test result state
 * @param action - The action being processed
 * @returns The new state
 */
export const testResultReducer = (state: ITestResultState = initialState.testResult, action: AnyAction): ITestResultState => {
  switch (action.type) {
    case SET_TEST_RESULT_PROGRESS:
      return { ...state, progressMessage: action.description };

    case LOAD_TEST_RESULT_ERROR:
      return { ...state, resultLoadErrorReason: action.reason, loadInProgress: false };

    case LOAD_TEST_RESULT_START:
      return {
        ...state,
        currentResult: null,
        downloadXmlUrl: "",
        downloadHtmlUrl: "",
        resultLoadErrorReason: "",
        progressMessage: "",
        loadInProgress: true,
      };

    case LOAD_TEST_RESULT_SUCCESS:
      return {
        ...state,
        currentResult: action.result,
        downloadXmlUrl: action.downloadXmlUrl,
        downloadHtmlUrl: action.downloadHtmlUrl,
        loadInProgress: false,
      };

    case SET_TEST_NODE_EXPANDED:
      return {
        ...state,
        currentResult: !state.currentResult
          ? state.currentResult
          : Utils.mapResult(state.currentResult, (n) => (n === action.node ? { expanded: action.expanded } : {})),
      };

    case SET_TEST_NODE_EXPAND_COLLAPSE_ALL:
      return {
        ...state,
        currentResult: !state.currentResult
          ? state.currentResult
          : Utils.mapResult(state.currentResult, () => ({ expanded: action.expanded })),
      };

    default:
      return state;
  }
};
